import config from '@/modules/config/functions/config';
import router from '@/modules/router/constants/router';
import i18next from 'i18next';
import * as Sentry from '@sentry/react';
import { match } from 'ts-pattern';

export default {
  enabled: config('sentry.enabled', true),
  dsn: config('sentry.dsn'),
  environment: match(import.meta.env.REACT_APP_BRANCH)
    .with('main', 'master', 'live', (branch) =>
      import.meta.env.MODE === 'production'
        ? 'production'
        : `${branch} (${import.meta.env.MODE})`
    )
    .otherwise((branch) =>
      import.meta.env.MODE === 'production'
        ? branch
        : `${branch} (${import.meta.env.MODE})`
    ),
  integrations: [
    Sentry.tanstackRouterBrowserTracingIntegration(router),
    Sentry.extraErrorDataIntegration(),
  ],
  tracesSampleRate: 1.0,
  beforeSend(event) {
    if (!event.tags) event.tags = {};
    // track user language
    if (i18next.isInitialized) event.tags.locale = i18next.language;
    // track platform
    event.tags.platform =
      window.ReactNativeWebViewConstants &&
      window.ReactNativeWebViewConstants.PLATFORM_OS
        ? 'webview'
        : 'browser';
    event.tags.version = import.meta.env.REACT_APP_VERSION_STRING;
    return event;
  },
} as Sentry.BrowserOptions;
